import { useMutation } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { createWorkout } from "api-client";
import { Icon } from "icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { SectionDialogEdit } from "src/components/SectionDialogEdit";

export { SectionDialogEdit } from "src/components/SectionDialogEdit";

export function SectionDialogCreate() {
  const { t } = useTranslation();
  const router = useRouter();
  const [sectionId, setSectionId] = useState<string | null>(null);

  const createSectionMutation = useMutation({
    mutationFn: async () => {
      const workoutRes = await createWorkout({
        body: {
          name: t("sectionsPage.newSectionName"),
          description: "",
          isInLibrary: true,
          isSectionOnly: true,
        },
      });
      const workout = workoutRes.data.data;
      return workout.id;
    },
    onSuccess: (workoutId) => {
      setSectionId(workoutId);
    },
  });

  function handleOpenChange(value: boolean) {
    if (!value) {
      setSectionId(null);
      router.invalidate();
    }
  }

  return (
    <>
      <Button
        onClick={() => {
          createSectionMutation.mutate();
        }}
        disabled={createSectionMutation.isPending}
      >
        <Icon name="tabler-plus" />
        <div>{t("sectionsPage.createSection")}</div>
      </Button>
      {sectionId && (
        <SectionDialogEdit
          sectionId={sectionId}
          open={true}
          onOpenChange={handleOpenChange}
        />
      )}
    </>
  );
}
